import {
  UPLOAD_IMAGE_ANNOUNCEMENT_REQUEST,
  UPLOAD_IMAGE_ANNOUNCEMENT_SUCCESS,
  UPLOAD_FILE_ANNOUNCEMENT_SUCCESS,
  UPLOAD_IMAGE_ANNOUNCEMENT_FAILURE,
  UPLOAD_IMAGE_ANNOUNCEMENT,
} from "../../actions/announcement/upload-image-action";

const initialState = {
  upload: null,
  isLoading: false,
  error: null,
  document: null,
};

const AnnouncementUploadImageReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPLOAD_IMAGE_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case UPLOAD_IMAGE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        upload: { ...action.payload },
      };
    case UPLOAD_FILE_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        document: { ...action.payload },
      };
    case UPLOAD_IMAGE_ANNOUNCEMENT:
      return {
        ...state,
        isLoading: false,
        upload: { ...action.payload },
      };
    case UPLOAD_IMAGE_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default AnnouncementUploadImageReducer;
